var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartIcon = function SvgHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4.52.667q.63.02 1.22.22h.04a.2.2 0 0 1 .06.04c.147.047.287.1.42.174l.253.113c.1.053.22.153.287.193s.14.08.2.126A4.18 4.18 0 0 1 9.567.667c.42 0 .84.06 1.24.194 2.46.8 3.347 3.5 2.606 5.86a8.5 8.5 0 0 1-2.006 3.206 25.6 25.6 0 0 1-4.22 3.306l-.167.1-.173-.107A25.4 25.4 0 0 1 2.6 9.92a8.6 8.6 0 0 1-2.008-3.2C-.16 4.36.727 1.66 3.213.848q.293-.1.594-.14h.08q.28-.04.56-.04zm5.94 2.107a.534.534 0 0 0-.673.333.545.545 0 0 0 .333.686c.427.16.713.58.713 1.047v.02c-.013.153.034.3.127.414s.233.18.38.193a.55.55 0 0 0 .527-.507v-.08a2.2 2.2 0 0 0-1.407-2.106"
  })));
};
export default SvgHeartIcon;